const blogLandingFilter = () => {
  const filterDropdownInit = () => {
    $('.blog_filter_wrapper .filter.tag-manager .filter__name').on(
      'click',
      (e) => {
        const $this = $(e.currentTarget)
          .parent()
          .closest('.filter.tag-manager');

        $this.toggleClass('is-open');
        if ($this.parents('.blog_filter_wrapper-desktop').length) {
          $('.blog_filter_wrapper-desktop .filter.tag-manager')
            .not($this)
            .removeClass('is-open');
        }
      },
    );
  };

  const filterMobileInit = () => {
    $('.blog_filter_wrapper-overlay').on('click', () => {
      closeFilterDrawer();
    });

    $('.blog_filter_mobile-close-button').on('click', () => {
      closeFilterDrawer();
    });

    $('.blog_filter_mobile_button:not(".is-open")').on('click', () => {
      openFilterDrawer();
    });

    $('.blog_filter_mobile-button--clear').on('click', () => {
      mobileClearButton();
    });

    $('.blog_filter_mobile-button--apply').on('click', () => {
      mobileApplyButton();
    });
  };

  const closeFilterDrawer = () => {
    $('.blog_filter_wrapper-overlay').removeClass('active');
    $('.blog_filter_wrapper-mobile').removeClass('is-open');
  };

  const openFilterDrawer = () => {
    $('.blog_filter_wrapper-overlay').addClass('active');
    $('.blog_filter_wrapper-mobile').addClass('is-open');
  };

  const mobileClearButton = () => {
    window.location.href = createFilterLink([]);
  };

  const mobileApplyButton = () => {
    const filterList = [];
    $('.blog_filter_mobile_list .filter__item.active').each(function () {
      const filterItem = $(this).data('filter-tag');
      filterList.push(filterItem);
    });

    const filterLink = createFilterLink(filterList);
    window.location.href = filterLink;
  };

  // keep the active filter when submitting the journal/recipe search bar
  const searchFormInit = () => {
    $('#journal-blog-search, #recipe-blog-search').on('submit', (e) => {
      const filterList = createFilterList();
      if (!filterList.length) return;

      e.preventDefault();
      const $form = $(e.currentTarget);
      const $searchInput = $form.find('input[type="text"]');
      const baseURL = window.location.origin + $form.attr('action');
      const searchParam = `${$searchInput.attr('name')}=${encodeURIComponent($searchInput.val())}`;
      const filterParams = filterList
        .map((item) => `filter=${item}`)
        .join('&');

      window.location.href = `${baseURL}?${searchParam}&${filterParams}`;
    });
  };

  const filterInit = () => {
    const isJournal = !!$('.main-blog#journal, .main-blog#news').length;
    let filterList = createFilterList();
    populateFilters(filterList, isJournal);

    $('.filter__item').on('click', (e) => {
      const $this = $(e.currentTarget);
      const filterItem = $this.find('button').text();

      const isMobileItem = !!$this.parents('.blog_filter_mobile_list').length;

      if (isJournal) {
        if (filterItem == 'all posts') {
          const filterLink = createFilterLink([]);
          window.location.href = filterLink;
        } else {
          const filterLink = createFilterLink([filterItem]);
          window.location.href = filterLink;
        }
      } else if (isMobileItem) {
        if (!$this.hasClass('active')) {
          $this.addClass('active');
        } else if ($this.hasClass('active')) {
          $this.removeClass('active');
        }
        populateMobileFilters($this);
      } else {
        if ($this.hasClass('filter__item__clear')) {
          const clearGroup = $this.data('clear-group');
          filterList = clearFilterGroup(filterList, clearGroup);
        } else if (!$this.hasClass('active')) {
          filterList = addToFilterList(filterList, filterItem);
        } else if ($this.hasClass('active')) {
          filterList = removeFromFilterList(filterList, filterItem);
        }

        const filterLink = createFilterLink(filterList);

        window.location.href = filterLink;
      }
    });
  };

  const createFilterList = () => {
    const filterList = [];
    const currentURL = window.location.href;
    if (currentURL.includes('filter=')) {
      const urlFilterList = currentURL.split('filter=').slice(1);
      urlFilterList.forEach((filterItem) => {
        filterItem = filterItem.replaceAll('&', '');
        filterItem = filterItem.replaceAll('%20', ' ');
        filterList.push(filterItem);
      });
    }
    return filterList;
  };

  const addToFilterList = (filterList, filterItem) => {
    filterList.push(filterItem);
    return filterList;
  };

  // clear all button on dropdown group
  const clearFilterGroup = (filterList, clearGroup) => {
    $(
      `.filter__container[data-filter-group=${clearGroup}] .filter__item.active`,
    ).each(function () {
      const filterItem = $(this).data('filter-tag');
      filterList = removeFromFilterList(filterList, filterItem);
    });
    return filterList;
  };

  const removeFromFilterList = (filterList, filterItem) => {
    filterList = filterList.filter((item) => item !== filterItem);
    return filterList;
  };

  // create link with all new filters
  const createFilterLink = (filterList) => {
    const baseURL = window.location.origin + window.location.pathname;
    const recipeSearchURL =
      $('.recipe-blog-search-bar').length &&
      $('.recipe-blog-search-bar').val() != ''
        ? `?recipe_query=${$('.recipe-blog-search-bar').val()}`
        : '';
    const journalSearchURL =
      $('.journal-blog-search-bar').length &&
      $('.journal-blog-search-bar').val() != ''
        ? `?journal_query=${$('.journal-blog-search-bar').val()}`
        : '';

    let filterLink = '';
    filterList.forEach((item, index) => {
      if (index == 0 && recipeSearchURL == '' && journalSearchURL == '') {
        filterLink += `?filter=${item}`;
      } else {
        filterLink += `&filter=${item}`;
      }
    });

    return baseURL + (recipeSearchURL || journalSearchURL) + filterLink;
  };

  // dropdown items select count + selected state
  const populateFilters = (filterList, isJournal) => {
    if (isJournal) {
      if (filterList.length) {
        const filterName = filterList[0];
        $('.blog_filter_wrapper-journal .filter__name')
          .text(`${filterName}`)
          .append(
            '<div class="filter__icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none"><path d="M-3.96853e-08 0.907894L0.92 -4.62466e-07L5.75 4.83L10.58 -4.02145e-08L11.5 0.907895L5.75 6.65789L-3.96853e-08 0.907894Z" fill="black"></path></svg></div>',
          );
      }
    } else {
      filterList.forEach((item) => {
        $(
          `.blog_filter_wrapper .filter__item[data-filter-tag='${item}']`,
        ).addClass('active');
      });
      $('.blog_filter_wrapper .filter.tag-manager').each(function () {
        const filterCount = $(this).find('.filter__item.active').length;
        if (filterCount > 0) {
          if ($(this).parents('.blog_filter_mobile_list').length) {
            $(this).find('.filter__name').append(`<span>${filterCount}</span>`);
          } else {
            const filterGroupName = $(this).find('.filter__name').text();
            $(this)
              .find('.filter__name')
              .text(`${filterGroupName} / ${filterCount}`);
          }
        }
      });
    }
  };

  const populateMobileFilters = (filterGroup) => {
    const filterCount = filterGroup
      .parents('.filter__container')
      .find('.filter__item.active').length;
    const filterGroupName = filterGroup
      .parents('.filter.tag-manager')
      .find('.filter__name');

    filterGroupName.find('span').remove();
    if (filterCount > 0) {
      filterGroupName.append(`<span>${filterCount}</span>`);
    }
  };

  filterDropdownInit();
  filterMobileInit();
  filterInit();
  searchFormInit();
};

export default blogLandingFilter;
